import { TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';

const UserTableHead = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Name</TableCell>
        <TableCell>Email</TableCell>
        <TableCell>Password</TableCell>
        <TableCell>Role</TableCell>
        <TableCell>States</TableCell>
        <TableCell>Last Login</TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
}
export default UserTableHead;